import * as Icons from "@ant-design/icons";

const IconMap = {
  UserOutlined: Icons.UserOutlined,
  WindowsOutlined: Icons.WindowsOutlined,
  FormOutlined: Icons.FormOutlined,
  DiffOutlined: Icons.DiffOutlined,
  ToolOutlined: Icons.ToolOutlined,
  ScheduleOutlined: Icons.ScheduleOutlined,
  SnippetsOutlined: Icons.SnippetsOutlined,
  DeliveredProcedureOutlined: Icons.DeliveredProcedureOutlined,
  DatabaseOutlined: Icons.DatabaseOutlined,
  VideoCameraOutlined: Icons.VideoCameraOutlined,
  UploadOutlined: Icons.UploadOutlined,
  CheckOutlined: Icons.CheckOutlined,
  CloseOutlined: Icons.CloseOutlined,
  EyeOutlined: Icons.EyeOutlined,
  MoreOutlined: Icons.MoreOutlined,
  ExclamationCircleFilled: Icons.ExclamationCircleFilled,
  PlusOutlined: Icons.PlusOutlined,
  MinusOutlined: Icons.MinusOutlined,
  MinusCircleOutlined: Icons.MinusCircleOutlined,
  DownloadOutlined: Icons.DownloadOutlined,
  EditOutlined: Icons.EditOutlined,
  DeleteOutlined: Icons.DeleteOutlined,
  PlusCircleTwoTone: Icons.PlusCircleTwoTone,
  SettingOutlined: Icons.SettingOutlined,
  LogoutOutlined: Icons.LogoutOutlined,
  MenuFoldOutlined: Icons.MenuFoldOutlined,
  MenuUnfoldOutlined: Icons.MenuUnfoldOutlined,
  SunOutlined: Icons.SunOutlined,
  MoonOutlined: Icons.MoonOutlined,
  ReloadOutlined: Icons.ReloadOutlined,
  UnorderedListOutlined: Icons.UnorderedListOutlined,
  PlayCircleOutlined: Icons.PlayCircleOutlined,
  MinusCircleTwoTone: Icons.MinusCircleTwoTone,
  SearchOutlined: Icons.SearchOutlined,
  HomeOutlined: Icons.HomeOutlined,
  ProfileOutlined: Icons.ProfileOutlined,
  CloseCircleOutlined: Icons.CloseCircleOutlined,
  CheckCircleOutlined: Icons.CheckCircleOutlined,
  ClockCircleOutlined: Icons.ClockCircleOutlined
};

export default IconMap;
